export default __webpack_public_path__ + "static/media/logo-info.9eff7c77.png";